const Actions = {
  EDIT: "EDIT",
  ADD_FILE: "ADD_FILE",
  ADD_FOLDER: "ADD_FOLDER",
  DELETE: "DELETE",
};
export const FolderTemplate = [
  {
    "type": "folder",
    "id": "id_tk0joxjpz",
    "disableCollapse": true,
    "readOnly": true,
    "name": "Deal Directory",
    "files": [
      {
        "type": "folder",
        "id": "id_y75ls0u9n",
        "readOnly": true,
        "name": "Outgoing",
        "files": [
          {
            "type": "folder",
            "id": "id_jntkq64k7",
            "readOnly": true,
            "name": "Structural",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_vh1c2y1j5",
            "readOnly": true,
            "name": "Electrical",
            "files": []
          }
        ]
      },
      {
        "type": "folder",
        "id": "id_r7b7jj3g4",
        "readOnly": true,
        "name": "Receipts",
        "files": []
      },
      {
        "type": "folder",
        "id": "id_s6f7z2whq",
        "readOnly": true,
        "name": "Photos",
        "files": [
          {
            "type": "folder",
            "id": "id_fif6vklwm",
            "readOnly": true,
            "name": "03-Commissioning",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_u2gnvc2n7",
            "readOnly": true,
            "name": "00-Asbestos Inspection",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_vg3sw6bh8",
            "readOnly": true,
            "name": "02-Installation",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_sphqzpwk9",
            "readOnly": true,
            "name": "01-Existing",
            "files": []
          }
        ]
      },
      {
        "type": "folder",
        "id": "id_jd8tsuqwn",
        "readOnly": true,
        "name": "Filing",
        "files": [
          {
            "type": "folder",
            "id": "id_gd5xlnmwq",
            "readOnly": true,
            "name": "Initial",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_x92zzkxn4",
            "readOnly": true,
            "name": "PAA",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_ho3k8lxxr",
            "readOnly": true,
            "name": "Sign Off",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_r67wjjhch",
            "readOnly": true,
            "name": "Received",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_v3shtsc8p",
            "readOnly": true,
            "name": "Asbestos Investigation",
            "files": []
          }
        ]
      },
      {
        "type": "folder",
        "id": "id_e5z9wp9kq",
        "readOnly": true,
        "name": "Plans",
        "files": [
          {
            "type": "folder",
            "id": "id_k1vs91w9d",
            "readOnly": true,
            "name": "Issued",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_j5lwvcs7n",
            "readOnly": true,
            "name": "Archive",
            "files": []
          }
        ]
      },
      {
        "type": "folder",
        "id": "id_eoxwzr9p7",
        "readOnly": true,
        "name": "Incoming",
        "files": [
          {
            "type": "folder",
            "id": "id_qchj3bp2o",
            "readOnly": true,
            "name": "Utility Bill",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_vgzf6v2g8",
            "readOnly": true,
            "name": "Roof Layout",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_y9j1ob7kb",
            "readOnly": true,
            "name": "Structural Letter",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_ytq96ftbd",
            "readOnly": true,
            "name": "Site Visit Notes",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_i4wh64d1n",
            "readOnly": true,
            "name": "Contract document",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_kpzp6t7g6",
            "readOnly": true,
            "name": "Project Information",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_w7gz2o5fn",
            "readOnly": true,
            "name": "Shading Report",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_d0pt8cb61",
            "readOnly": true,
            "name": "Module & Equipment",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_zsk7kx7xz",
            "readOnly": true,
            "name": "3 Line diagram",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_ox3dwxu7l",
            "readOnly": true,
            "name": "Close-out",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_6ld3nrxu5",
            "readOnly": true,
            "name": "Elevation Survey",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_qf7kxnxdp",
            "readOnly": true,
            "name": "Existing Plans",
            "files": []
          },
          {
            "type": "folder",
            "id": "id_w1lscsjr1",
            "readOnly": true,
            "name": "Correspondence",
            "files": []
          }
        ]
      }
    ]
  }
]


export default Actions;